import { render } from "./ViewableFullStar.vue?vue&type=template&id=5cf0e71c&scoped=true"
import script from "./ViewableFullStar.vue?vue&type=script&lang=js"
export * from "./ViewableFullStar.vue?vue&type=script&lang=js"

import "./ViewableFullStar.vue?vue&type=style&index=0&id=5cf0e71c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf0e71c"]])

export default __exports__